// Re-export of GraphQL-related functionality for the sole purpose of being able to mock them from within unit tests.

import {
  DpaIdCollabGraphqlUseFolderListItems,
  DpaIdCollabGraphqlUseFolderLists,
  DpaIdCollabGraphqlUseFolders,
  DpaIdCollabGraphqlUseMutation,
  DpaIdCollabGraphqlUseQuery
  // @ts-ignore
} from "@dpa-connect/dpa-id-collab";

export default {
  DpaIdCollabGraphqlUseFolderListItems,
  DpaIdCollabGraphqlUseFolderLists,
  DpaIdCollabGraphqlUseFolders,
  useMutation: DpaIdCollabGraphqlUseMutation,
  useQuery: DpaIdCollabGraphqlUseQuery
};
